import one from "./Wands01.jpg";
import two from "./Wands02.jpg";
import three from "./Wands03.jpg";
import four from "./Wands04.jpg";
import five from "./Wands05.jpg";
import six from "./Wands06.jpg";
import seven from "./Wands07.jpg";
import eight from "./Wands08.jpg";
import nine from "./Wands09.jpg";
import ten from "./Wands10.jpg";
import page from "./WandsPage.jpg";
import knight from "./WandsKnight.jpg";
import queen from "./WandsQueen.jpg";
import king from "./WandsKing.jpg";

const wands = [
  one,
  two,
  three,
  four,
  five,
  six,
  seven,
  eight,
  nine,
  ten,
  page,
  knight,
  queen,
  king,
];

export default wands;
